import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName'
})
export class FullNamePipe implements PipeTransform {

  transform(user: any): string {
    if (user) {
      return `${user.name} ${user.surname} ${user.second_surname}`;
    }
    else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/full-name.pipe.ts